import { render, staticRenderFns } from "./CardDetails.vue?vue&type=template&id=2557a568"
import script from "./CardDetails.vue?vue&type=script&lang=js"
export * from "./CardDetails.vue?vue&type=script&lang=js"
import style0 from "./CardDetails.vue?vue&type=style&index=0&id=2557a568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports